import { useAddress } from './AddressProvider';
import { useReputation } from '../../react-query/reputation/useReputation';

export const useReputationWithAddress = () => {
  const { address } = useAddress();
  return useReputation(address);
};
